export enum EtxeTokenVaultActions {
  PROPERTY_CO_OWNER_INVITATION = 'etxe_property_co_owner_invitation',
}
